export const EMPTY_ESTABLISHMENT_FILTERS = Object.freeze({
  type: "",
  status: "",
});

export const ESTABLISHMENT_TYPES = ["Préscolaire", "Primaire", "CEG"];
export const ESTABLISHMENT_STATUSES = ["Public", "Privé"];

export function compactEstablishmentFilters(filters = {}) {
  const params = {};
  ["type", "status"].forEach((key) => {
    const value = String(filters[key] ?? "").trim();
    if (value) params[key] = value;
  });
  return params;
}

export function establishmentTypeOptions(t) {
  return [
    { id: "", text: t ? t("establishments.filter.all_types", "All types") : "All types" },
    ...ESTABLISHMENT_TYPES.map((value) => ({ id: value, text: value })),
  ];
}

export function establishmentStatusOptions(t) {
  return [
    { id: "", text: t ? t("establishments.filter.all_statuses", "All statuses") : "All statuses" },
    ...ESTABLISHMENT_STATUSES.map((value) => ({ id: value, text: value })),
  ];
}

export function buildAssignmentEstablishmentParams(sptid, filters = {}) {
  return {
    sptid,
    ...compactEstablishmentFilters(filters),
  };
}

export function buildAssignmentCreationEntries(values, forceReassignment) {
  return [
    ["AsignId", values.teachers],
    ["EstabId", values.establishment],
    ["AssigDateTime", values.date],
    ["ForceReassignment", String(forceReassignment)],
  ];
}
